export function forceLayout (element) {
  /*
    clientHeight has the side effect that it forces a layout (https://gist.github.com/paulirish/5d52fb081b3570c81e3a).
    the property assignment makes sure that compilers/optimizers will not remove the operation.
   */
  window.__noop = element.clientHeight; // eslint-disable-line no-underscore-dangle
}
